import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import i18next from "i18next";

dayjs.extend(localizedFormat);

/**
 * Used to show date and time in the client
 */
export function getPostfachFormat(date: Date): string {
  return i18next.t('date-time.postfix', {datetime: dayjs(date, {locale: i18next.language}).format('L LT')});
}

/**
 * Used for the filename of PDF, when user download a message
 */
export function getPdfDateTimeFormat(date: Date): string {
  return dayjs(date, {locale: i18next.language}).format('L LT');
}

/**
 * Used within the PDF, when user download a message, to show the date and time of the message
 */
export function getPdfDateTimeFormat2(date: Date): string {
  return dayjs(date, {locale: i18next.language}).format('L | LT');
}

/**
 * The title (not filename!) of the PDF, when user download a message
 */
export function getPdfDateFormat(date: Date): string {
  return dayjs(date, {locale: i18next.language}).format('L');
}
